import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';

@AcDialog({
  width: 400,
  height: 150
})
@Component({
  selector: 'alternative-routing-sip-reasons-dialog',
  templateUrl: './alternative-routing-sip-reasons-dialog.component.html',
  styleUrls: ['./alternative-routing-sip-reasons-dialog.component.scss']
})
export class AlternativeRoutingSipReasonsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('alternativeRoutingSipReasonsDialog') alternativeRoutingSipReasonsDialog: NgForm;
  sipReason: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.sipReason = dialogConfig.dialogData;
    dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.alternativeRoutingSipReasonsDialog.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.alternativeRoutingSipReasonsDialog.form.valid;
    });
  }

}
